import React, { useState, useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import { ArrowLeftIcon } from '@heroicons/react/solid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const datesByYear = {
  2020: {
    from: new Date("2020-01-01"),
    to: new Date("2020-12-31"),
  },
  2021: {
    from: new Date("2021-01-01"),
    to: new Date("2021-12-31"),
  },
  2022: {
    from: new Date("2022-01-01"),
    to: new Date("2022-12-31"),
  },
  2023: {
    from: new Date("2023-01-01"),
    to: new Date("2023-12-31"),
  },
  2024: {
    from: new Date("2024-01-01"),
    to: new Date("2024-12-31"),
  },
};

const AddAttendanceRecord = ({ open, onClose, selectedYear, setSelectedYear, userId, onCreate, loading }) => {
  const [formData, setFormData] = useState({
    present_days: '',
    absent_days: '',
    paid_leaves: '',
  });

  useEffect(() => {
    if (!open) {
      setFormData({
        present_days: '',
        absent_days: '',
        paid_leaves: '',
      });
      setSelectedYear(null);
    }
  }, [open, setSelectedYear]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleYearChange = (date) => {
    setSelectedYear(date);
  };

  const getFromDate = () => {
    if (selectedYear) {
      const year = selectedYear.getFullYear();
      return datesByYear[year]?.from.toLocaleDateString() || "Select year for the from date";
    }
    return "Select year for the from date";
  };

  const getToDate = () => {
    if (selectedYear) {
      const year = selectedYear.getFullYear();
      return datesByYear[year]?.to.toLocaleDateString() || "Select year for the to date";
    }
    return "Select year for the to date";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const year = selectedYear.getFullYear();
    const from_date = datesByYear[year]?.from.toISOString().split('T')[0];
    const to_date = datesByYear[year]?.to.toISOString().split('T')[0];
    onCreate({
      user_id: userId,
      year,
      from_date,
      to_date,
      ...formData,
    });
  };

  return (
    <Drawer anchor={'right'} open={open} onClose={onClose}>
      <div className='h-full bg-white px-8' style={{ width: 'calc(100vw - 250px)' }}>
        <form className=' space-y-8' onSubmit={handleSubmit}>
          <div className='flex items-center justify-between  py-5 border-b border-gray-200 sticky z-40 top-0 bg-white'>
            <div className='flex items-center space-x-3'>
              <ArrowLeftIcon className=' text-gray-700 w-8 h-8 cursor-pointer' onClick={onClose} />
              <p className='text-gray-700 text-3xl font-semibold'>Add Attendance Record</p>
            </div>
            <button type="submit" className=' bg-color1 px-5 py-2 text-lg text-white rounded-md' disabled={loading}>
              <div className='flex items-center justify-center space-x-2'>
                <span>{loading ? 'Creating...' : 'Create Record'}</span>
              </div>
            </button>
          </div>
          <div className=' '>
            <div className='grid grid-cols-3 gap-5 py-5'>
              <div>
                <div className=''>
                  <label className='label'>Year: </label>
                  <DatePicker
                    selected={selectedYear}
                    onChange={handleYearChange}
                    showYearPicker
                    dateFormat="yyyy"
                    className='input'
                    placeholderText='Select Year'
                  />
                </div>
              </div>
              <div>
                <div>
                  <label className='label'>From Date: </label>
                  <input type="text" value={getFromDate()} readOnly className='input' placeholder='Select year for the from date' />
                </div>
              </div>
              <div>
                <div>
                  <label className='label'>To Date: </label>
                  <input type="text" value={getToDate()} readOnly className='input' placeholder='Select year for the to date' />
                </div>
              </div>
              <div>
                <div>
                  <label className='label'>Present Days: </label>
                  <input
                    type="number"
                    name="present_days"
                    value={formData.present_days}
                    onChange={handleInputChange}
                    required={true}
                    className='input'
                    placeholder='Enter Present Days'
                  />
                </div>
              </div>
              <div>
                <div>
                  <label className='label'>Absent Days: </label>
                  <input
                    type="number"
                    name="absent_days"
                    value={formData.absent_days}
                    onChange={handleInputChange}
                    required={true}
                    className='input'
                    placeholder='Enter Absent Days'
                  />
                </div>
              </div>
              <div>
                <div>
                  <label className='label'>Paid Leaves: </label>
                  <input
                    type="number"
                    name="paid_leaves"
                    value={formData.paid_leaves}
                    onChange={handleInputChange}
                    required={true}
                    className='input'
                    placeholder='Enter Paid Leaves'
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Drawer>
  );
};

export default AddAttendanceRecord;
